import { organisationConstants } from '../../../_constants/organisation.constants';
import { organisationService } from '../../../_services/organisation.service';

export const getManageMetricAction = {
    getManageMetricHandler,
    getCompetencyData,
    getAttributeList,
    competencyMetricPrefill
};

function getManageMetricHandler(orgId, compId) {
    return dispatch => {
        dispatch(request());
        organisationService.getManageMetricHandler(orgId, compId)
            .then(
                manageMetricList => {
                    dispatch(success(manageMetricList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_MANAGE_METRIC_LIST,  } }
    function success(manageMetricList) { return { type: organisationConstants.RECEIVE_MANAGE_METRIC_LIST, manageMetricList } }
    function failure(error) { return { type: organisationConstants.MANAGE_METRIC_LIST_ERROR, error } }
}

function getCompetencyData() {
    return dispatch => {
        dispatch(request());
        organisationService.getCompetencyService()
            .then(
                manageCompetencyList => {
                    dispatch(success(manageCompetencyList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_COMPETENCY,  } }
    function success(manageCompetencyList) { return { type: organisationConstants.RECIEVE_COMPETENCY, manageCompetencyList } }
    function failure(error) { return { type: organisationConstants.ERROR_COMPETENCY, error } }
}

function getAttributeList() {
    return dispatch => {
        dispatch(request());
        organisationService.getAttributeService()
            .then(
                attributeList => {
                    dispatch(success(attributeList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ATTRIBUTE_LIST,  } }
    function success(attributeList) { return { type: organisationConstants.RECIEVE_ATTRIBUTE_LIST, attributeList } }
    function failure(error) { return { type: organisationConstants.ERROR_ATTRIBUTE_LIST, error } }
}

function competencyMetricPrefill() {
    return dispatch => {
        dispatch(request());
        organisationService.competencyMetricPrefillService()
            .then(
                competencyList => {
                    dispatch(success(competencyList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_PREFILL_COMPETENCY,  } }
    function success(competencyList) { return { type: organisationConstants.RECIEVE_PREFILL_COMPETENCY, competencyList } }
    function failure(error) { return { type: organisationConstants.ERROR_PREFILL_COMPETENCY, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/ManageMetric/getManageMetricList.action.js